import { useValidAmountStrAndSwapAndTopUpInfo } from '@ui/views/card-cronos/core/utils/validations';
import { useMemo } from 'react';

export enum PriceImpactWarningType {
  Acceptable = 0,
  Warning = 0.05,
  Error = 0.15,
}

export const usePriceImpactWarningType = () => {
  const { swapAndTopUpInfo } = useValidAmountStrAndSwapAndTopUpInfo();
  return useMemo(() => {
    if (!swapAndTopUpInfo?.needToSwapFirst) {
      return PriceImpactWarningType.Acceptable;
    }
    if (
      swapAndTopUpInfo.priceImpactExcludeLpFee >= PriceImpactWarningType.Error
    )
      return PriceImpactWarningType.Error;
    if (
      swapAndTopUpInfo.priceImpactExcludeLpFee >= PriceImpactWarningType.Warning
    )
      return PriceImpactWarningType.Warning;
    return PriceImpactWarningType.Acceptable;
  }, [swapAndTopUpInfo]);
};
